const rEmail =
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

export function isEmail(text: string) {
  return rEmail.test(text);
}

export function slugify(text: string) {
  return text
    .toString()
    .normalize("NFD") // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, "") // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, "-");
}

/**
 * Validates if a string contains exactly 10 numeric digits and no other characters
 * @param value The string to validate
 * @returns true if the string contains exactly 10 numeric digits and nothing else
 */
export const isTenDigits = (value: string): boolean => {
  const digitsOnly = /^\d+$/.test(value);

  return digitsOnly && value.length === 10;
};
